import classNames from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const SkipTraceOrderPlacedPage = () => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        "bg-background-surface-neutral",
        "flex",
        "flex-col",
        "gap-y-5",
        "items-center",
        "justify-center",
        "h-full",
        "w-full"
      )}
      data-testid="skip-tracing-order-placed"
    >
      <div
        className={classNames(
          "flex",
          "flex-col",
          "gap-y-5",
          "text-center",
          "items-center",
          "justify-center",
          "w-[330px]"
        )}
      >
        <i
          className={classNames("icon-lt-clock-line", "text-8xl", "text-text-base-primary")}
          data-testid="clock-icon"
        />
        <span className="text-xl font-semibold">{t("sites.skip_tracing.order_placed.order_created")}</span>
        <span className="text-md">{t("sites.skip_tracing.order_placed.first_message_line")}</span>
        <span className="text-md">{t("sites.skip_tracing.order_placed.second_message_line")}</span>
      </div>
    </div>
  );
};
